import packageJson from '../../package.json';

/**
 * The fork's first service. At M1 it has one job: prove that a `{ name, create }`
 * factory handed to `servicesManager.registerService` from `preRegistration` lands in
 * `registeredServiceNames`. M2 adds the real ones (auth, HttpService, orthancClient).
 *
 * `registerService` takes a plain factory OBJECT, not a class (ServicesManager.ts:28).
 * Two upstream hazards this shape avoids, both live from M2 onward:
 *
 *   - A duplicate `name` is a silent no-op: log.warn + return, no throw, no replace
 *     (:39-44), test-locked at ServicesManager.test.js:82-87.
 *   - `registeredServiceNames` tracks `name` only, never `altName` (:63 vs :53-56).
 *     No `altName` is declared here. The one realistic collision route is a class with
 *     a static `create`, which registers under `Class.name` — PascalCase, the same
 *     namespace as every `altName` — so `class SegmentationService { static create() {} }`
 *     would pass the :39 guard and silently clobber cornerstone's alias.
 */
export class SycaiService {
  public static readonly REGISTRATION = {
    name: 'sycaiService',
    create: () => new SycaiService(),
  };

  /**
   * The one line M1 prints. Carries id and version only — parent §5.1 drops ~103 log
   * statements from the fork, including ones printing auth state and cookie values, and
   * this must not restart that. It ships to production deliberately (§7 risk 3): it
   * doubles as a deploy marker. The version printed is this extension's OWN
   * `package.json` version (`@ohif/extension-sycai`), not the monorepo root's — it tracks
   * the monorepo version only by convention (both happen to be bumped together today), so
   * an independent version bump of this package alone would make the banner misreport
   * which OHIF base is actually running.
   */
  public getBanner(): string {
    return `[sycai] ${packageJson.name} ${packageJson.version} registered`;
  }
}
